import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header.js";
import { usermanageService } from "../../services/usermanageService";
import {
    Container,
    Row,
    Col,
    Table,
    Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import Select from 'react-select';

const EwsGraph = () => {
    const [matrixData, setMatrixData] = useState({});
    const [reviewerlist, setReviewerData] = useState([]);
    const [loading, setLoading] = useState(false); 
    const months = [{value:'01',label : 'Jan'},{value:'02',label :'Feb'},{value:'03',label :'March'},{value:'04',label :'April'},{value:'05',label :'May'},{value:'06',label :'June'},{value:'07',label :'July'},{value:'08',label :'Aug'},{value:'09',label :'Sept'},{value:10,label :'Oct'},{value:11,label :'Nov'},{value:12,label :'Dec'}];
    const [monthdata, setmonthdata] = useState(months);
    const initialData = {
        month_year : '',
        reviewer_id : '',
       }
      const [inputFields, setInputfields] = useState(initialData);
    useEffect(() => {
        get_data()
    }, []);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState([]);
    const handleCellClick = async (risk, performer) => {
        // setPopupTitle(`${risk} Risk - ${performer}`);
        // setPopupVisible(true);
        setPopupOpen(true);
        setPopupData([]);    
        const requestParams = {
            month_year: inputFields.month_year,
            risk: risk,
            performance: performer,
            user_id: inputFields.reviewer_id
        };
    
        try {
            const response = await usermanageService.getEwsMatrixDetails(requestParams);
            console.log('aa',response.data)
            if (response.status) {
               
                setPopupData(response.data);
            } else {
                setPopupData([]);
            }
        } catch (error) {
            setPopupData([]);
        }
    };
    const get_data = async () => {
        setLoading(true); // start loading
        // try {
            const response = await usermanageService.getEwsMatrix(inputFields);
            if (response.data.status) {
                setMatrixData(response.data.data);
                setReviewerData(response.data.reviewer_arr);
            } else {
                toast.error("Failed to fetch graph data");
            }
        // } catch (error) {
        //     toast.error("Error fetching graph data: " + (error.message || error));
        // }
        setLoading(false); // done loading
    };
    const scoreLabels = {
      'High': 'Above 31',
      'Medium': '16 - 31',
      'Low': 'Below 16'
    };
    const riskLevels = ['High', 'Medium', 'Low'];
    const performerLevels = ['High', 'Medium', 'Low'];

    const getCellColor = (risk, performer) => {
        if (risk === 'High' && performer === 'Low') return 'bg-gray-400 text-black';
        if (risk === 'High' && performer === 'Medium') return 'bg-orange-300 text-black';
        if (risk === 'High' && performer === 'High') return 'bg-red-500 text-black';
        
        if (risk === 'Medium' && performer === 'Low') return 'bg-gray-300 text-black';
        if (risk === 'Medium' && performer === 'Medium') return 'bg-yellow-300 text-black';
        if (risk === 'Medium' && performer === 'High') return 'bg-orange-400 text-black';
        
        if (risk === 'Low' && performer === 'Low') return 'bg-gray-300 text-black';
        if (risk === 'Low' && performer === 'Medium') return 'bg-gray-300 text-black';
        if (risk === 'Low' && performer === 'High') return 'bg-green-300 text-black';

        return '';
    };

    function inputhandler(e,field) {
        if(field=='month_year'){
          setInputfields((prevInputFields)=>({ ...prevInputFields, [field]: e.target.value } ));
        }else{
          console.log()
        setInputfields((prevInputFields) => ({
          ...prevInputFields,
          [field]: e.value,
        }));
        }
      
      }
    return (
        <>
        <Header />
        <Container className="mt--7"  fluid>
        <Row className="-12" >
        <div className="col-xl-2 col-md-3 col-xs-12">
                    <h3 className="clientformtag"> Select User</h3>
        <Select 
                        className="input-group-alternative " 
                        name="reviewer_id"
                        options={reviewerlist} // set list of the data
                        onChange={(e) => inputhandler(e,'reviewer_id')}
                        searchable
                        isClearable={false}
                    />
                    </div>
                    <div className="col-xl-2 col-md-3 col-xs-12">
                    <h3 className="clientformtag"> Select month</h3>
                    <input type="month"
                                      className="form-control"
                                      name="month_year"
                                      onChange={(e) => { inputhandler(e,'month_year')}}
                                      value={inputFields.month_year}
                                      options={monthdata}
                                      required
                                      />
                                       {inputFields.month_year && <div style={{ marginTop: 20, lineHeight: '25px' }}></div>}
                      
                  </div>
                  <div className="col-xl-3 col-md-3 col-xs-12">
                    <br></br>
                    <Button 
                        className="col-xl-6 btn btn-primary"  
                        onClick={get_data}
                        disabled={loading} // disable button while loading
                    >
                        {loading ? 'Loading...' : 'Search'}
                    </Button>
                    </div>
                    </Row>
                    <Row>
        <div className="overflow-auto p-4">
        <table className="table-auto border-collapse border border-gray-400 text-center">
            <thead>
                <tr>
                    <th rowSpan="3" colSpan="3" className="border border-gray-400 px-4 py-2 bg-gray-100 font-bold" style={{textAlign:'center' }}>CV Index</th>
                    <th colSpan="3" className="border border-gray-400 px-4 py-2 bg-gray-100 font-bold" style={{textAlign:'center' }}>CRITICALITY</th>
                </tr>
               
                <tr>
                {performerLevels.map((label, idx) => (
                    <th key={idx} className="border border-gray-400 px-4 py-2 bg-gray-100 font-semibold">{label}</th>
                ))}
                </tr>
                <tr>
                    <th  className="border border-gray-400 px-4 py-2 bg-gray-100 font-semibold" style={{textAlign:'center' }}>A</th>
                    <th  className="border border-gray-400 px-4 py-2 bg-gray-100 font-semibold" style={{textAlign:'center' }}>B</th>
                    <th  className="border border-gray-400 px-4 py-2 bg-gray-100 font-semibold" style={{textAlign:'center' }}>C</th>
                </tr>
            </thead>
            <tbody>
                {riskLevels.map((risk, i) => (
                <tr key={i}>
                     <td className="border border-gray-400 px-2 py-2 bg-gray-100 font-bold">
           <b> {risk}</b>
        </td>
                    {/* Add VULNERABILITY column on first row only, spanning all rows */}
                    {i === 0 && (
                        
                    <td rowSpan={riskLevels.length } style={{ writingMode: 'vertical-rl',textAlign:'center' }} className="border border-gray-400 px-2 py-2 bg-gray-100 font-bold rotate-text align-middle">
                        <div className="flex flex-col justify-center h-full"><b>VULNERABILITY</b></div>
                    </td>
                    )}

                    {/* Score label per row */}
                    <td className="border border-gray-400 px-2 py-2 bg-gray-100 font-semibold" style={{ writingMode: 'vertical-rl',textAlign:'center' }}>
                    <b>Score: <br></br>{scoreLabels[risk]}</b>
                    </td>

                    {/* Loop over performer levels (A, B, C) */}
                    {performerLevels.map((perf, j) => {
                    const key = `${risk} Risk - ${perf}`;
                    const value = matrixData[key] ?? 0;
                    const cellClass = getCellColor(risk, perf); // Add color logic as per your function
                    return (
                        <td key={j} className={`border border-gray-400 px-4 py-2 ${cellClass}`}
                        onClick={() => handleCellClick(risk, perf)}>
                        {value}
                        </td>
                    );
                    })}
                </tr>
                ))}
            </tbody>
            </table>

        </div>
        <Modal isOpen={popupOpen} toggle={() => setPopupOpen(false)} size="xl">
  <ModalHeader toggle={() => setPopupOpen(false)}>KRO Matrix Details</ModalHeader>
  <ModalBody>
    <Table className="align-items-center table-flush" responsive>
      <thead className="thead-light">
        <tr>
          <th>Name</th>
          <th>Reviewer</th>
          <th>Month</th>
          <th className="whitespace">One on one assessment</th>
          <th className="whitespace">Performance Trend</th>
          <th className="whitespace">Leave Record</th>
          <th className="whitespace">Behaviour/Motivation</th>
          <th className="whitespace">Tenure in Current role</th>
          <th className="whitespace">Manager's Perspective</th>
          <th>Rating Score</th>
          <th>Rating</th>
        </tr>
      </thead>
      <tbody>
        {popupData && popupData.length ? (
          popupData.map((item, i) => {
            if (!item) return null;

            const riskScore = (100 - item.total_weightage_score / 5).toFixed(2);
            let riskLabel = "";
            if (riskScore < 16) riskLabel = "Low Risk";
            else if (riskScore < 32) riskLabel = "Medium Risk";
            else riskLabel = "High Risk";

            let performLabel = "";
            if (item.manager_prespective <= 1) performLabel = "Low Performer";
            else if (item.manager_prespective <= 3) performLabel = "Medium Performer";
            else performLabel = "High Performer";

            let rowClass = "";
            if (riskLabel === 'Low Risk') {
              rowClass = performLabel === 'Low Performer' ? 'yellow-row' : 'green-row';
            } else if (riskLabel === 'Medium Risk') {
              rowClass = 'orange-row';
            } else if (riskLabel === 'High Risk') {
              rowClass = performLabel === 'High Performer' ? 'darkorange-row' : 'red-row';
            }

            return (
              <tr key={i} className={rowClass}>
                <td>{item.name}</td>
                <td>{item.reviewer}</td>
                <td>{item.month}</td>
                <td>{item.one_on_one}</td>
                <td>{item.performance_trend}</td>
                <td>{item.leave_record}</td>
                <td>{item.behavior_motivation}</td>
                <td>{item.tenure_in_role}</td>
                <td>{item.manager_prespective}</td>
                <td>{riskScore}</td>
                <td>{performLabel} - {riskLabel}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="11">No Data Found!</td>
          </tr>
        )}
      </tbody>
    </Table>
  </ModalBody>
</Modal>
        </Row>
       
        </Container>
        </>
    );
}
export default EwsGraph;
